import React, { PureComponent } from 'react';
import { ReactTinyLink } from 'react-tiny-link'

import schemify from 'url-schemify';

import config from '../config'

export default class UrlPreview extends PureComponent {
    state = {
        hasError: false
    }

    handleError = e => {
        this.setState({
            hasError: true
        });
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        });
    }

    render() {
        if (!config.ENABLE_URL_PREVIEWS || !this.props.url || this.state.hasError) {
            return null;
        }

        return (
            <div className="url-preview">
                {
                    this.props.url ? (
                        <ReactTinyLink
                            url={schemify(this.props.url)}
                            width={'367px'}
                            maxLine={1}
                            cardSize="large"
                            target="_blank"
                            apiKey={config.MICROLINK_API_KEY}
                            onError={this.handleError}
                        />
                    ) : null
                }
            </div>
        )
    }
}
